import { render, staticRenderFns } from "./OnTimeMetricWidget.vue?vue&type=template&id=52a01d8a&scoped=true"
import script from "./OnTimeMetricWidget.vue?vue&type=script&lang=ts"
export * from "./OnTimeMetricWidget.vue?vue&type=script&lang=ts"
import style0 from "./OnTimeMetricWidget.vue?vue&type=style&index=0&id=52a01d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a01d8a",
  null
  
)

export default component.exports